<template>
  <base-layout>
    <h1 slot="header">
      {{ `app.patients.` + selectedTab | trans }}
    </h1>
    <v-app id="vuetify-app">
      <v-tabs icons-and-text v-model="selectedTab" slider-color="success">
        <v-tab href="#active">
          {{ `app.patients.active` | trans }}
          <v-icon>person</v-icon>
        </v-tab>
        <v-tab href="#archive">
          {{ `app.patients.archive` | trans }}
          <v-icon>cloud</v-icon>
        </v-tab>
        <v-tab-item
            :key="`active`"
            :value="`active`">
          <patients-table :group="`active`" ref="activePatients" @edit-patient="editPatient">
            <template slot="header_actions">
              <patient-manage-modal ref="patientModal" @patient-saved="patientSaved" :show-redirect-button="true"/>
            </template>
          </patients-table>
        </v-tab-item>
        <v-tab-item
            :key="`archive`"
            :value="`archive`">
          <patients-table :group="`archive`" ref="archivePatients" @edit-patient="editPatient">
          </patients-table>
        </v-tab-item>
      </v-tabs>
    </v-app>
  </base-layout>
</template>
<script>
import {mapGetters, mapActions} from "vuex";

export default {
  props: {
    routes: Object,
    group: String,
  },
  data: () => ({
    selectedTab: null,
  }),
  computed: {
    ...mapGetters(['hasPermission']),
  },
  created() {
    this.selectedTab = this.group;
    this.fetchPatientsCount();
  },
  methods: {
    ...mapActions(['fetchPatient', 'fetchPatientsCount']),
    async editPatient(payload) {
      await this.fetchPatient(payload.id)
      this.$refs.patientModal.open();
    },
    patientSaved() {
      this.$refs.activePatients.fetchData();
      this.$refs.archivePatients.fetchData();
    }
  },
  mounted() {
    if (window.location.href.includes('/patients/create')) {
      this.$refs.patientModal.open(true);
    }
  },
  watch: {
    selectedTab: {
      handler() {
        this.$refs[this.selectedTab + 'Patients'].fetchData();
      }
    }
  }
}
</script>
